<template>
  <div class="container">
    <head-nav-bar title="自助开单" :fixed="true" />
    <div class="mt-header-nav" style="paddingTop:1px">
      <van-cell-group>
        <van-field name="radio" label="取药方式">
          <template #input>
            <van-radio-group
              v-model="takeMedicineWayCode"
              @change="onTakeMedicineWayChange"
              direction="horizontal"
            >
              <van-radio name="0">自提</van-radio>
              <van-radio name="1">快递</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="takeMedicineWayCode == 1"
          v-model="takeMedicineAddressText"
          readonly
          label="收货信息"
          class="readonly"
          placeholder="点击此处添加"
          @click="onOpenEditAdd()"
        />
      </van-cell-group>
      <div class="header-box">
        <div>名称</div>
        <div>金额(元)&nbsp;/&nbsp;规格&nbsp;/&nbsp;单位&nbsp;/&nbsp;数量</div>
      </div>

      <van-cell-group style="max-height: 62vh;overflow-y: scroll;">
        <van-cell
          v-for="item in selfItemList"
          :key="item.hisItemId"
          clickable
          style="padding-left: 5px;padding-right: 5px;"
        >
          <div slot="title" style="padding-left:10px">
            <b>{{ item.itemName }}</b>
          </div>
          <template #icon>
            <van-checkbox
              icon-size="16px"
              v-model="item.checked"
              @change="countTotal()"
            />
          </template>

          <template #right-icon>
            <span
              >￥{{ item.unitPrice }}&nbsp;/&nbsp;{{
                item.specifications
              }}&nbsp;/&nbsp;{{ item.unitName }}&nbsp;</span
            >
            <van-stepper
              min="1"
              v-model="item.num"
              buttonSize="22"
              @change="countTotal()"
            />
          </template>
        </van-cell>
      </van-cell-group>
      <p class="total">合计：{{ total }}</p>
    </div>
    <van-button
      @click="onSubmit"
      :loading="onSubmitLoading"
      type="info"
      class="submit"
      >开单申请</van-button
    >
    <form ref="form" method="post" name="auto_submit_form" :action="payAction">
      <input
        v-for="item in payParams"
        :key="item.Key"
        type="hidden"
        :name="item.key"
        :value="item.value || ' '"
      />
      <input
        type="submit"
        value="立刻提交"
        style="display:none"
        name="name"
        id="name"
      />
    </form>
    <action-sheet v-model="show" :actions="payMethod" @select="onSelect" />
    <van-dialog
      v-model="addressShow"
      title="收货信息"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
    >
      <van-icon @click="onCloseEditAdd()" name="cross" class="close" />
      <van-field
        label="收货人"
        v-model="takeMedicineAddress.fastMailName"
        required
      />
      <van-field
        type="tel"
        label="电话"
        v-model="takeMedicineAddress.fastMailPhone"
        required
      />
      <van-field
        v-model="takeMedicineAddress.fullAdd"
        is-link
        readonly
        required
        label="省市区"
        placeholder="请选择所在地区"
        @click="addressChooseShow = true"
      />
      <van-field
        label="详细地址"
        v-model="takeMedicineAddress.fastMailAddr"
        required
      />
      <van-button type="info" block @click="onAddSubmit">确认保存</van-button>
    </van-dialog>
    <van-popup v-model="addressChooseShow" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        :field-names="fieldNames"
        @close="addressChooseShow = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import {
  Cell,
  CellGroup,
  Button,
  Col,
  Row,
  Checkbox,
  CheckboxGroup,
  Notify,
  Dialog,
  Radio,
  RadioGroup,
  ActionSheet,
  Field,
  Stepper,
  Cascader,
  Popup,
  Icon,
} from "vant"
import { checkPhone } from "@/utils/common"
import wx from "weixin-jsapi"
import SelectPicker from "@/components/select-picker/function"
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    ActionSheet,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Col.name]: Col,
    [Row.name]: Row,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.Component.name]: Dialog.Component,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Stepper.name]: Stepper,
    [Popup.name]: Popup,
    [Cascader.name]: Cascader,
  },
  data() {
    return {
      onSubmitLoading: false,
      total: 0,
      options: [],
      fieldNames: {
        text: "name",
        value: "code",
        children: "items",
      },
      addressChooseShow: false,
      cascaderValue: "",
      addressShow: false,
      takeMedicineWayText: "自提",
      takeMedicineWayCode: "0",
      show: false,
      info: {},
      selfItemList: [],
      checked: true,
      payMethod: [],
      payParams: [],
      payWechatData: {},
      payAction: "",
      oldAddText: {},
      oldTakeMedicineAddress: {},
      takeMedicineAddress: {
        fastMailName: "",
        fastMailPhone: "",
        fastMailAddrProvince: "",
        fastMailAddrCity: "",
        fastMailAddrCounty: "",
        fastMailAddr: "",
      },
      takeMedicineAddressText: "",
      oldTakeMedicineAddressText: "",
    }
  },
  created() {
    this.params = this.$route.query
    if (this.params && this.params.id) {
      this.$post("Contact_Info", { Id: this.params.id }).then((res) => {
        this.info = res.data
        this.takeMedicineAddress = {
          fastMailName: this.info.fastMailName,
          fastMailPhone: this.info.fastMailPhone,
          fastMailAddrProvince: this.info.fastMailAddrProvince,
          fastMailAddrCity: this.info.fastMailAddrCity,
          fastMailAddrCounty: this.info.fastMailAddrCounty,
          fastMailAddr: this.info.fastMailAddr,
          fullAdd:
            this.info.fastMailAddrProvince +
            this.info.fastMailAddrCity +
            this.info.fastMailAddrCounty,
        }

        this.takeMedicineAddressText =
          this.info.fastMailName +
          "," +
          this.info.fastMailPhone +
          "," +
          this.info.fastMailAddrProvince +
          this.info.fastMailAddrCity +
          this.info.fastMailAddrCounty +
          this.info.fastMailAddr
        if (!this.takeMedicineAddressText) {
          this.takeMedicineAddressText = ""
        }
      })
    }
    this.$post("GetSelfItemList", {})
      .then((res) => {
        res.data.map((item) => {
          item.checked = false
          item.num = 1
        })
        this.selfItemList = res.data
      })
      .catch(() => {})
    this.$post("Common_SelectData", { Code: "MobilePayMethodDic" }).then(
      (res) => {
        res.data.MobilePayMethodDic.map((item) => {
          this.payMethod.push({
            name: item.text,
            ...item,
          })
        })
      }
    )
    this.getAddressData()
  },
  methods: {
    onTakeMedicineWayChange() {},
    onAddSubmit() {
      //验证
      const verifyRes = this.verifyForm()
      if (verifyRes === false) {
        return false
      }
      this.takeMedicineAddressText =
        this.takeMedicineAddress.fastMailName +
        "," +
        this.takeMedicineAddress.fastMailPhone +
        "," +
        this.takeMedicineAddress.fastMailAddrProvince +
        this.takeMedicineAddress.fastMailAddrCity +
        this.takeMedicineAddress.fastMailAddrCounty +
        this.takeMedicineAddress.fastMailAddr
      this.addressShow = false
    },
    onFinish({ selectedOptions }) {
      console.log(this.cascaderValue)
      this.show = false
      if (selectedOptions.length == 3) {
        this.takeMedicineAddress.fastMailAddrProvince = selectedOptions[0].name
        this.takeMedicineAddress.fastMailAddrCounty = selectedOptions[1].name
        this.takeMedicineAddress.fastMailAddrCity = selectedOptions[2].name
      }
      this.takeMedicineAddress.fullAdd = selectedOptions
        .map((option) => option.name)
        .join("/")
    },
    getAddressData() {
      this.$post("His_GetAddressList", {}).then((res) => {
        const addObj = res.data
        let options = []
        options = addObj.provinceList
        for (let i = 0; i < addObj.provinceList.length; i++) {
          addObj.provinceList[i].items = []
          for (let j = 0; j < addObj.cityList.length; j++) {
            addObj.cityList[j].items = []
            if (addObj.cityList[j].parentCode == addObj.provinceList[i].code) {
              addObj.provinceList[i].items.push(addObj.cityList[j])
            }
            for (let k = 0; k < addObj.countyList.length; k++) {
              if (addObj.countyList[k].parentCode == addObj.cityList[j].code) {
                addObj.cityList[j].items.push(addObj.countyList[k])
              }
            }
          }
        }
        this.options = options
      })
    },
    verifyForm() {
      const verifyFields = [
        "fastMailName",
        "fastMailPhone",
        "fastMailAddr",
        "fullAdd",
      ]
      let is = false
      for (let i = 0; i < verifyFields.length; i++) {
        const item = verifyFields[i]
        if (item == "fastMailName") {
          const verifyIdCard = this.takeMedicineAddress[item]
          //判断姓名不能有特殊符号
          var regEn = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/im,
            regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
          if (regEn.test(verifyIdCard) || regCn.test(verifyIdCard)) {
            Notify("收货人不能包含特殊字符.")
            return false
          }
          if (!this.takeMedicineAddress[item]) {
            Notify("收货人不得为空！")
            return false
          }
        }
        if (item == "fastMailPhone") {
          // 验证手机号
          if (!checkPhone(this.takeMedicineAddress[item])) {
            Notify("请输入正确的电话")
            return false
          }
        }
        if (item == "fastMailAddr") {
          const verifyIdCard = this.takeMedicineAddress[item]
          if (!verifyIdCard) {
            Notify("详细地址不得为空！")
            return false
          }
        }
        if (item == "fullAdd") {
          if (!this.takeMedicineAddress[item]) {
            Notify("请选择地区！")
            return false
          }
        }
      }
      if (is) {
        Notify("带*号必填，请完善信息！")
        return false
      }

      return true
    },
    onSubmit() {
      const that = this
      this.onSubmitLoading = true
      const json = {
        ifFastMail: this.takeMedicineWayCode,
        hisItems: [],
        PatientName: that.info.cardholderName,
        Sex: that.info.cardholderSex + "",
        Birthday: that.info.cardholderBirthDate,
        Age: that.info.age,
        DiagnosisCardNo: that.info.diagnosisCardNo,
        Address: that.info.cardholderContactAddress,
        IdentityNo: that.info.identityDocNo,
        ContactPhone: that.info.cardholderContactPhone,
        fastMailAddrProvince: "",
        fastMailAddrCity: "",
        fastMailAddrCounty: "",
        fastMailAddr: "",
        fastMailName: "",
        fastMailPhone: "",
      }
      if (!this.takeMedicineAddressText && this.takeMedicineWayCode == 1) {
        this.onSubmitLoading = false
        Notify("请填写收货信息！")
        return false
      }
      let hasChecked = false
      for (let index = 0; index < this.selfItemList.length; index++) {
        if (this.selfItemList[index].checked) {
          hasChecked = true
          json.hisItems.push({
            hisItemId: this.selfItemList[index].hisItemId,
            number: this.selfItemList[index].num,
          })
        }
      }
      if (hasChecked) {
        json.fastMailAddrProvince = this.takeMedicineAddress.fastMailAddrProvince
        json.fastMailAddrCity = this.takeMedicineAddress.fastMailAddrCity
        json.fastMailAddrCounty = this.takeMedicineAddress.fastMailAddrCounty
        json.fastMailAddr = this.takeMedicineAddress.fastMailAddr
        json.fastMailName = this.takeMedicineAddress.fastMailName
        json.fastMailPhone = this.takeMedicineAddress.fastMailPhone
        console.log(json)
        this.$post("AddSelfNewOutpatientInfo", json)
          .then((res) => {
            that.payWechatData = {
              outpatientLogId: res.data.outpatientLogId,
              doctorId: res.data.doctorId,
              departmentId: res.data.departmentId,
              visitDate: res.data.visitDate,
            }
            that.toPay()
          })
          .finally(() => {
            this.onSubmitLoading = false
          })
      } else {
        this.onSubmitLoading = false
        Notify("请勾选药品！")
      }
    },
    toPay() {
      if (this.payMethod.length == 1) {
        this.onSelect(this.payMethod[0])
      } else {
        this.show = true
        return
      }
      this.loading = true
    },
    onSelect(item) {
      this.show = false
      delete item.id
      this.$post("Pay_Wechat", {
        Id: this.payWechatData.outpatientLogId,
        PayType: "2",
        DoctorId: this.payWechatData.doctorId,
        DepartmentId: this.payWechatData.departmentId,
        VisitDate: this.payWechatData.visitDate,
        DiagnosisCardNo: this.info.diagnosisCardNo,
        OutTradeNo: Date.now() + "",
        payMethod: item.value,
      }).then((res) => {
        this.loading = false
        this.setWxConfig(res.data)
      })
    },
    setWxConfig(option) {
      const that = this
      if (option.apiUrl) {
        this.payAction = option.apiUrl
        this.payParams = option.params.map((item) => {
          item.value.replace('"', "&quot;")
          return item
        })
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      } else {
        wx.config({
          debug: false, //这里一般在测试阶段先用true，等打包给后台的时候就改回false,
          appId: option.appId,
          timestamp: option.timeStamp,
          nonceStr: option.nonceStr,
          signature: option.paySign,
          jsApiList: ["chooseWXPay"],
        })
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {
              console.log(res, "seccess")
            },
            fail: function(res) {
              console.log(res, "fail")
            },
          })
          that.jsApiCall(option)
        })
      }
    },
    jsApiCall(option) {
      const _this = this
      wx.ready(function() {
        wx.chooseWXPay({
          appId: option.appId,
          timestamp: option.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: option.nonceStr, // 支付签名随机串，不长于 32
          package: option.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: option.paySign, // 支付签名
          success: function(res) {
            console.log(res)
            //跳转到支付成功页面有这个页面
            // _this.getInfo();
            Notify({ background: "rgb(7,193,96)", message: "支付成功" })
            _this.$router.push({
              name: "userBill",
            })
          },
          cancel: function(res) {
            console.log(res)
            //取消支付
            // _this.$router.push({
            //   name: "servePreOrderResult",
            //   query: { Id: _this.Id }
            // });
          },
          fail: function(res) {
            console.log(res)
            alert("支付失败，请重试")
          },
        })
      })
    },
    showSelectCardType() {
      const _this = this
      this.selectPickerModal = SelectPicker({
        columns: [
          {
            id: "0",
            text: "自提",
          },
          {
            id: "1",
            text: "快递",
          },
        ],
        defaultValue: _this.takeMedicineWayCode,
        change: (data) => {
          _this.takeMedicineWayCode = data.id
          _this.takeMedicineWayText = data.text
        },
      })
    },
    countTotal() {
      let price = 0
      for (let index = 0; index < this.selfItemList.length; index++) {
        if (this.selfItemList[index].checked) {
          price = this.add(
            this.multiply(
              this.selfItemList[index].unitPrice,
              this.selfItemList[index].num
            ),
            price
          )
        }
      }
      this.total = price
    },
    // 乘法 解决精度问题
    multiply(num1, num2) {
      const num1Str = num1.toString()
      const num2Str = num2.toString()
      const num1Digits = num1Str.includes(".")
        ? num1Str.length - num1Str.indexOf(".") - 1
        : 0
      const num2Digits = num2Str.includes(".")
        ? num2Str.length - num2Str.indexOf(".") - 1
        : 0
      const precision = num1Digits + num2Digits

      const num1Int = parseInt(num1Str.replace(".", ""))
      const num2Int = parseInt(num2Str.replace(".", ""))

      let result = num1Int * num2Int
      result /= Math.pow(10, precision)

      return result
    },
    // 加法 解决精度问题
    add(num1, num2) {
      const num1Digits = (num1.toString().split(".")[1] || "").length
      const num2Digits = (num2.toString().split(".")[1] || "").length
      const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits))
      return (num1 * baseNum + num2 * baseNum) / baseNum
    },
    onCloseEditAdd() {
      console.log(this.oldTakeMedicineAddress)
      this.addressShow = false
      this.takeMedicineAddress = cloneDeep(this.oldTakeMedicineAddress)
    },
    onOpenEditAdd() {
      console.log(this.takeMedicineAddress)
      this.addressShow = true
      this.oldTakeMedicineAddress = cloneDeep(this.takeMedicineAddress)
    },
  },
}
</script>

<style lang="less" scoped>
.header-box {
  font-size: 12px;
  color: rgb(147, 147, 147);
  display: flex;
  padding: 10px;
  justify-content: space-between;
  background-color: rgb(244, 244, 244);
}

.submit {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  padding: 10px;
  background-color: #fff;
  border-radius: 20px;
}
.close {
  color: #999;
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 20px;
}
.total {
  width: 98%;
  text-align: right;
  padding-top: 10px;
  font-size: 14px;
  color: red;
}
</style>
